import React from "react";
import { useMediaQuery } from "react-responsive";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import Kpi from "../../components/KPI/Kpi";
import { ReactComponent as StoreCircleIcon } from "../../assets/icons/store-circle.svg";
import { ReactComponent as TrophyCircleIcon } from "../../assets/icons/trophy-circle.svg";
import styled from "styled-components";

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  width: "100%",
});

function OverviewDesktop({ app, config }) {
  const notFullHd = useMediaQuery({ query: "(max-width: 1536px)" });

  const { selections } = useSelections();
  const selectedQuarter = Kpi({
    app,
    objectId: "jzfBCy",
  });

  const [value, setValue] = React.useState("Distribuidores");
  const [valueEvolucao, setValueEvolucao] = React.useState("Pontuação");

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleChangeEvolucao = (event) => {
    setValueEvolucao(event.target.value);
  };

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutCardsWrapper>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"flex-start"}
            sx={{
              paddingLeft: "16px",
            }}
          >
            {/* FIRST ROW */}
            <Grid
              container
              flexDirection={"row"}
              justifyContent={"flex-start"}
              alignItems={"baseline"}
            >
              <Grid
                item
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"flex-start"}
                gap={"16px"}
                width={"30%"}
              >
                {/* STORES CARD */}
                <Grid item>
                  <Card
                    app={app}
                    header={{
                      hardTitle: "Lojas",
                    }}
                    style={{
                      height: "100%",
                    }}
                  >
                    <Grid
                      display={"flex"}
                      flexDirection={"row"}
                      justifyContent={"space-between"}
                      alignItems={"center"}
                      gap={"18px"}
                      width={"100%"}
                    >
                      <Grid
                        container
                        flexDirection={"row"}
                        justifyContent={"flex-start"}
                        alignItems={"center"}
                        display={"flex"}
                        gap={"18px"}
                      >
                        <StoreCircleIcon />
                        <Grid
                          display={"flex"}
                          flexDirection={"column"}
                          justifyContent={"space-between"}
                          gap={"16px"}
                          alignItems={"flex-end"}
                          item
                        >
                          <Grid
                            item
                            flexDirection={"row"}
                            display={"flex"}
                            alignItems={"center"}
                            gap={"10px"}
                          >
                            <span className="label">Base Lojas:</span>

                            <div className="container-numbers">
                              <LayoutWrapper>
                                <Card
                                  app={app}
                                  style={{ width: "71px", height: "100%" }}
                                  className={"container-table"}
                                >
                                  <NativeObject
                                    app={app}
                                    key="PmwrW"
                                    reference={{ id: "PmwrW" }}
                                    style={{ height: "27px" }}
                                  />
                                </Card>
                              </LayoutWrapper>
                            </div>
                          </Grid>

                          <Grid
                            display={"flex"}
                            gap={"15px"}
                            flexDirection={"row"}
                            justifyContent={"flex-start"}
                            alignItems={"center"}
                            item
                          >
                            <span className="label">Lojas Novas:</span>

                            <div className="container-numbers number-02">
                              <LayoutWrapper>
                                <Card
                                  app={app}
                                  style={{ width: "61px", height: "100%" }}
                                  className={"container-table"}
                                >
                                  <NativeObject
                                    app={app}
                                    key="CKyc"
                                    reference={{ id: "CKyc" }}
                                    style={{ height: "27px" }}
                                  />
                                </Card>
                              </LayoutWrapper>
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item className="container-porcente">
                        <LayoutWrapper>
                          <Card
                            app={app}
                            style={{ width: "71px", height: "100%" }}
                            className={"container-table badge"}
                          >
                            <NativeObject
                              app={app}
                              key="UGMLjqS"
                              reference={{ id: "UGMLjqS" }}
                              style={{ height: "27px" }}
                            />
                          </Card>
                        </LayoutWrapper>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                {/* AWARDS CARD */}
                <Grid item xs>
                  <Card
                    app={app}
                    header={{
                      hardTitle: "Pontuação",
                    }}
                    style={{
                      height: "100%",
                    }}
                  >
                    <Grid
                      container
                      flexDirection={"row"}
                      justifyContent={"space-between"}
                      alignItems={"center"}
                      item
                      xs
                    >
                      <Grid
                        container
                        flexDirection={"row"}
                        justifyContent={"flex-start"}
                        alignItems={"center"}
                        item
                        xs
                        gap={2}
                      >
                        <Grid item>
                          <TrophyCircleIcon />
                        </Grid>
                        <Grid
                          container
                          flexDirection={"column"}
                          justifyContent={"space-between"}
                          alignItems={"flex-end"}
                          item
                          xs
                          gap={1.5}
                        >
                          <Grid
                            container
                            flexDirection={"row"}
                            justifyContent={"flex-start"}
                            alignItems={"center"}
                            item
                            xs={12}
                            gap={1.5}
                          >
                            <Grid item className="container-month">
                              <LayoutWrapper>
                                <Card
                                  app={app}
                                  style={{ width: "81px", height: "100%" }}
                                  className={"container-table"}
                                >
                                  <NativeObject
                                    app={app}
                                    key="dwqjvqz"
                                    reference={{ id: "dwqjvqz" }}
                                    style={{ height: "27px" }}
                                  />
                                </Card>
                              </LayoutWrapper>
                            </Grid>

                            <Grid item className="container-numbers number-01">
                              <LayoutWrapper>
                                <Card
                                  app={app}
                                  style={{
                                    width: "71px",
                                    height: "100%",
                                    marginLeft: "-10px",
                                  }}
                                  className={"container-table"}
                                >
                                  <NativeObject
                                    app={app}
                                    key="VjMgmPy"
                                    reference={{ id: "VjMgmPy" }}
                                    style={{ height: "27px" }}
                                  />
                                </Card>
                              </LayoutWrapper>
                            </Grid>
                          </Grid>

                          <Grid
                            container
                            flexDirection={"row"}
                            justifyContent={"flex-start"}
                            alignItems={"center"}
                            item
                            xs={12}
                            gap={1.5}
                          >
                            <Grid item className="container-month">
                              <LayoutWrapper>
                                <Card
                                  app={app}
                                  style={{ width: "71px", height: "100%" }}
                                  className={"container-table"}
                                >
                                  <NativeObject
                                    app={app}
                                    key="qFYTaT"
                                    reference={{ id: "qFYTaT" }}
                                    style={{ height: "27px" }}
                                  />
                                </Card>
                              </LayoutWrapper>
                            </Grid>
                            <Grid item className="container-numbers number-02">
                              <LayoutWrapper>
                                <Card
                                  app={app}
                                  style={{ width: "71px", height: "100%" }}
                                  className={"container-table"}
                                >
                                  <NativeObject
                                    app={app}
                                    key="KMpXeTk"
                                    reference={{ id: "KMpXeTk" }}
                                    style={{ height: "27px" }}
                                  />
                                </Card>
                              </LayoutWrapper>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item className="container-porcente">
                        <LayoutWrapper>
                          <Card
                            app={app}
                            style={{ width: "71px", height: "100%" }}
                            className={"container-table badge"}
                          >
                            <NativeObject
                              app={app}
                              key="KMpXeTk"
                              reference={{ id: "KMpXeTk" }}
                              style={{ height: "27px" }}
                            />
                          </Card>
                        </LayoutWrapper>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>

              <Grid item width={"70%"}>
                <LayoutWrapper>
                  <Card
                    app={app}
                    header={{
                      hardTitle: "Lojas Novas por Região",
                    }}
                    style={{
                      height: "328px",
                    }}
                  >
                    <div className="container-maps-graphs">
                      <NativeObject
                        app={app}
                        key="WbxqY"
                        reference={{ id: "WbxqY" }}
                        style={{ width: "70%", height: "240px" }}
                      />

                      <NativeObject
                        app={app}
                        key="ESsepXj"
                        reference={{ id: "ESsepXj" }}
                        style={{ width: "30%", height: "240px" }}
                      />
                    </div>
                  </Card>
                </LayoutWrapper>
              </Grid>
            </Grid>
          </Grid>
        </LayoutCardsWrapper>

        <LayoutCardsWrapper>
          <Grid
            container
            display={"flex"}
            flexDirection={"row"}
            gap={"16px"}
            className="container-line-02"
            paddingLeft={"16px"}
          >
            <Card
              app={app}
              exportTable
              exportContainer
              exportTableId="mUQEYe"
              header={{
                hardTitle: "Ranking Grupo Produto",
              }}
              style={{ width: "30%", height: "100%" }}
              className={"container-table"}
            >
              <NativeObject
                app={app}
                key="mUQEYe"
                reference={{ id: "mUQEYe" }}
                style={{ height: "385px" }}
              />
            </Card>

            <Card
              app={app}
              header={{
                hardTitle: "Ranking Pontuação",
              }}
              style={{ width: "32.5%", height: "100%" }}
              className={"container-table"}
            >
              <FormControl className="container-radios">
                <RadioGroup
                  row
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={value}
                  onChange={handleChange}
                  defaultValue={value}
                >
                  <FormControlLabel
                    value="Distribuidores"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#d21078",
                          "&.Mui-checked": {
                            color: "#d21078",
                          },
                        }}
                      />
                    }
                    label="Distribuidores"
                  />

                  <FormControlLabel
                    value="Vendedores"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#d21078",
                          "&.Mui-checked": {
                            color: "#d21078",
                          },
                        }}
                      />
                    }
                    label="Vendedores"
                  />
                </RadioGroup>
              </FormControl>

              <>
                {value === "Distribuidores" ? (
                  <NativeObject
                    app={app}
                    key="mcRVVV"
                    reference={{ id: "mcRVVV" }}
                    style={{ height: "340px" }}
                  />
                ) : (
                  <NativeObject
                    app={app}
                    key="KAFj"
                    reference={{ id: "KAFj" }}
                    style={{ height: "340px" }}
                  />
                )}
              </>
            </Card>

            <Card
              app={app}
              header={{
                hardTitle: "Evolução",
              }}
              style={{ width: "32.5%", height: "100%" }}
              className={"container-table"}
            >
              <FormControl className="container-radios">
                <RadioGroup
                  row
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={valueEvolucao}
                  onChange={handleChangeEvolucao}
                  defaultValue={value}
                >
                  <FormControlLabel
                    value="Pontuação"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#d21078",
                          "&.Mui-checked": {
                            color: "#d21078",
                          },
                        }}
                      />
                    }
                    label="Pontuação"
                  />

                  <FormControlLabel
                    value="Venda"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#d21078",
                          "&.Mui-checked": {
                            color: "#d21078",
                          },
                        }}
                      />
                    }
                    label="Lojas Novas"
                  />
                </RadioGroup>
              </FormControl>

              <>
                {valueEvolucao === "Pontuação" ? (
                  <NativeObject
                    app={app}
                    key="PhUxAJ"
                    reference={{ id: "PhUxAJ" }}
                    style={{ height: "340px" }}
                  />
                ) : (
                  <NativeObject
                    app={app}
                    key="ppGEyxX"
                    reference={{ id: "ppGEyxX" }}
                    style={{ height: "340px" }}
                  />
                )}
              </>
            </Card>
          </Grid>
        </LayoutCardsWrapper>

        <LayoutCardsWrapper>
          <Grid
            item
            width={"100%"}
            sx={{
              padding: "0 16px",
              marginTop: "16px",
            }}
          >
            <Card
              app={app}
              exportTable
              exportContainer
              exportTableId="EjpPah"
              header={{
                hardTitle: "Lojas por níveis",
              }}
              style={{ width: "100%", height: "100%" }}
              className={"container-table"}
            >
              <NativeObject
                app={app}
                key="EjpPah"
                reference={{ id: "EjpPah" }}
                style={{ height: "385px" }}
              />
            </Card>
          </Grid>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

OverviewDesktop.defaultProps = {
  app: null,
  config: {},
};

OverviewDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OverviewDesktop;
